export default "__VITE_ASSET__BkLOLDwi__"